export default __webpack_public_path__ + "991277720feb9aa3f3cf39f0a4c4ba2c.png";